<template>
  <v-dialog v-model="show" persistent @keydown.esc="hide" width="600">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        :small="isButtonSmall"
        :text="isButtonText"
        color="primary"
        class="ma-2"
      >
        <v-icon v-if="buttonIcon" left small>{{ buttonIcon }}</v-icon>
        {{ buttonTitle }}
      </v-btn>
    </template>

    <v-card :loading="loading">
      <v-card-title class="grey lighten-2" primary-title>
        <v-row>
          <v-col>
            <span>
              {{ `${title} ${$t("instructions.comments.title")}` }}
            </span>
          </v-col>
          <v-col cols="auto">
            <v-btn icon @click="hide"><v-icon>close</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="max-height: 66vh; overflow-y: auto;">
        <v-row
          v-for="ic in instructionComments"
          :key="ic.id"
          :justify="isMe(ic) ? 'end' : 'start'"
        >
          <v-tooltip :left="isMe(ic)" :right="!isMe(ic)">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-bind="attrs"
                v-on="on"
                class="my-1 chat-text-chip"
                :color="isMe(ic) ? 'primary' : ''"
              >
                <router-link
                  v-if="ic.employee && !isMe(ic)"
                  class="pr-2"
                  :to="{
                    name: 'employee',
                    params: { id: ic.employee.id },
                  }"
                  >{{ ic.employee | nameId }}
                </router-link>
                {{ ic.comment }}
              </v-chip>
            </template>
            <span> {{ ic.created | dateTime }}</span>
          </v-tooltip>
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-form ref="instructionCommentForm" style="width: 100%;">
          <v-textarea
            v-model="comment"
            @keydown.enter="addComment"
            outlined
            hide-details="auto"
            auto-grow
            filled
            rows="1"
            :rules="[rules.length]"
          />
        </v-form>
        <v-btn
          :loading="loading"
          :disabled="!comment"
          color="primary"
          class="ml-2"
          text
          @click="addComment"
          >{{ $t("dialog.send") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

import AddInstructionCommentMutation from "@/graphql/mutation/instruction/AddInstructionComment.gql";

export default {
  props: {
    instructionComments: {
      type: Array,
      required: true,
    },
    versionId: {
      type: [String, Number],
      required: true,
    },
    buttonIcon: {
      type: String,
      default: undefined,
    },
    buttonTitle: {
      type: String,
      default: "",
    },
    isButtonSmall: {
      type: Boolean,
      default: true,
    },
    isButtonText: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      comment: "",
      show: false,
      loading: false,
      rules: {
        length: (value) => {
          return (
            (value && value.length <= 256) ||
            this.$i18n.tc("validation.length", 256)
          );
        },
      },
    };
  },

  computed: {
    ...mapState(["me"]),
  },
  methods: {
    isMe(instructionComment) {
      return (
        instructionComment.employee &&
        this.me.id == instructionComment.employee.id
      );
    },
    hide() {
      this.$refs.instructionCommentForm.reset();
      this.show = false;
    },
    addComment() {
      if (!this.$refs.instructionCommentForm.validate()) {
        return;
      }
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: AddInstructionCommentMutation,
          variables: {
            versionId: this.versionId,
            employeeId: this.me.id,
            comment: this.comment,
          },
        })
        .then((res) => {
          this.$emit("comment-added", res.data.comments);
          this.$refs.instructionCommentForm.reset();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.chat-text-chip {
  min-height: 32px;
  height: 100%;
  white-space: normal;
  line-height: unset;
}
</style>
